

// Charts

import Card from "@/views/util/Card.vue";
import GradientLineChart from "@/examples/Charts/GradientLineChart.vue";
import ActiveUsersChart from "@/examples/Charts/ActiveUsersChart.vue";

import ReportsBarChart from "@/examples/Charts/ReportsBarChart.vue";

import Carousel from "./components/Carousel.vue";
import IncidentesCard from "./components/IncidentesCard.vue";
import AtrasadosCard from "./components/AtrasadosCard.vue";

import PlayerCard from "./components/PlayerCard.vue";

import {
  faHandPointer,
  faUsers,
  faCreditCard,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";


import { defineComponent, ref } from 'vue';

import fintailapi from "../api";
import {useStore} from "vuex";

export default defineComponent({
  name: "dashboard-default",
  data() {
    return {
      dash: {cards:[], pedidos:[]},
      rotas: [],
      incidentes:[],
      atrasados:[],
      init: this.doInit(),
      sales: {
        us: {
          country: "United States",
          sales: 2500,
          value: "$230,900",
          bounce: "29.9%"
        },
        germany: {
          country: "Germany",
          sales: "3.900",
          value: "$440,000",
          bounce: "40.22%"
        },
        britain: {
          country: "Great Britain",
          sales: "1.400",
          value: "$190,700",
          bounce: "23.44%"
        },
        brasil: {
          country: "Brasil",
          sales: "562",
          value: "$143,960",
          bounce: "32.14%"
        },
      },
      redBarChart: {
          chartData: {
            labels: ['Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            datasets: [{
              label: 'Sales',
              data: [25, 20, 30, 22, 17, 29]
            }]
          },
          extraOptions: {}
        },
      lineChart:{
        data: {
          labels: ["Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
          datasets: [
            {
              label: "Mobile apps",
              tension: 0.4,
              borderWidth: 0,
              pointRadius: 0,
              borderColor: "#4BB543 ",
              backgroundColor: "#4BB543 ",
              fill: true,
              data: [0, 0, 0, 0, 0, 0, 1000, 100, 10000],
              maxBarThickness: 6,
            },
          ],
        },

      }
    };
  },
  components: {
    Card,
    GradientLineChart,
    Carousel,
    IncidentesCard,
    AtrasadosCard,
    ActiveUsersChart,
    ReportsBarChart,
    PlayerCard,
  },
   methods: {
      async goRotas() {
        this.$router.push('/rotas/criar');
      },
      async goPedidos() {
        this.$router.push('/pedidos');
      },
      async doInit() {
          fintailapi.get('/dashboard').then((response:any) => {

              this.dash = response.data;
              
      
              this.lineChart.data.labels = this.dash.pedidos.map((item:any) => item.data);
              this.lineChart.data.datasets[0].data = this.dash.pedidos.map((item:any) => item.total_pedidos);


              this.getRotas()

          }).catch((error:any) => {


          })
      },
      async getRotas() {

          fintailapi
          .get(`/rotas/hoje`)
          .then(async(response) => {

              this.rotas = response.data;
              this.getIncidentes()

          }).catch((error:any) => {


          })
      },
      async getIncidentes() {

          fintailapi
          .get(`/rotas/hoje/incidentes`)
          .then(async(response) => {

              this.incidentes = response.data;
              this.getAtrasados()

          }).catch((error:any) => {


          })
      },

      async getAtrasados() {

          fintailapi
          .get(`/rotas/hoje/atrasados`)
          .then(async(response) => {

              this.atrasados = response.data;

          }).catch((error:any) => {


          })
      },
      calculaConclusao(pedidos:any) {

        const totalPedidos      = pedidos.length;
        const pedidosConcluidos = pedidos.filter((p:any) => p.status_entrega === 2).length;
        const percentualConclusao = totalPedidos > 0 ? Math.round((pedidosConcluidos / totalPedidos) * 100) : 0;


        const color = percentualConclusao > 80 ? 'success':percentualConclusao>40?'warning':'danger'

        return (`<span   class="badge bg-gradient-${color}" >${percentualConclusao}%</span>`);

     },
   },
});
